import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { protectedResources } from '../auth/auth.config';
import {
  ComponentCredentialDto,
  ComponentCredentialListDto,
  validationResponseDto,
} from '../models/component-credentials.model';

@Injectable({
  providedIn: 'root',
})
export class ComponentCredentialsService {
  private apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ComponentCredentialListDto> {
    return this.http.get<ComponentCredentialListDto>(
      `${this.apiEndpoint}/license/thirdparty`,
    );
  }

  create(payload: ComponentCredentialDto): Observable<ComponentCredentialDto> {
    return this.http.post<ComponentCredentialDto>(
      `${this.apiEndpoint}/license/thirdparty`,
      payload,
    );
  }

  getById(componentCredentialId: string): Observable<ComponentCredentialDto> {
    const encodedCredentialId = encodeURIComponent(componentCredentialId);
    return this.http.get<ComponentCredentialDto>(
      `${this.apiEndpoint}/license/thirdparty/${encodedCredentialId}`,
    );
  }

  update(
    componentCredentialId: string,
    payload: ComponentCredentialDto,
  ): Observable<ComponentCredentialDto> {
    const encodedCredentialId = encodeURIComponent(componentCredentialId);
    return this.http.put<ComponentCredentialDto>(
      `${this.apiEndpoint}/license/thirdparty/${encodedCredentialId}`,
      payload,
    );
  }

  delete(componentCredentialId: string): Observable<void> {
    const encodedCredentialId = encodeURIComponent(componentCredentialId);
    return this.http.delete<void>(
      `${this.apiEndpoint}/license/thirdparty/${encodedCredentialId}`,
    );
  }

  validateCredential(
    credential: ComponentCredentialDto,
  ): Observable<validationResponseDto> {
    return this.http.post<validationResponseDto>(
      `${this.apiEndpoint}/license/thirdparty/validate`,
      credential,
    );
  }
}
